"use client";

import { PremiumOfferPageBanner } from "@/app/(home)/pricing/components/premium-offer-page-banner";
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
} from "@/components/ui/dialog";
import {
  PortalName,
  withRenderPortal,
  type WithRenderPortalProps,
} from "@/context/portal-context";
import { PricingContent } from "./pricing-content";

export interface PricingModalProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
}

function PricingModalBase({
  open,
  onClose,
  onOpenChange,
}: PricingModalProps & WithRenderPortalProps) {
  const handleOpenChange = (next: boolean) => {
    if (!next) onClose();
    onOpenChange?.(next);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        widthClassName="sm:max-w-6xl"
        className="flex max-h-[75vh] flex-col gap-0 overflow-hidden p-0"
        showCloseButton={false}
        closeBtnClassName="top-5 right-6 z-51 text-white transition-transform duration-200 hover:scale-110 data-[state=open]:text-white dark:text-white [&_svg:not([class*='size-'])]:size-6"
      >
        <PremiumOfferPageBanner
          hideOnLargeScreens={false}
          slotAfter={
            <div
              className="flex p-1"
              onClick={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
              }}
            >
              <DialogCloseButton className="text-white hover:text-white dark:text-white dark:hover:text-white" />
            </div>
          }
          fallbackSlot={
            <div className="flex h-10 shrink-0 items-center justify-end bg-white px-4 md:px-8 dark:bg-zinc-900">
              <DialogCloseButton className="text-white hover:text-white dark:text-white dark:hover:text-white" />
            </div>
          }
        />
        <div className="flex-1 overflow-y-auto px-4 py-6 md:p-8">
          <PricingContent subscriptionPlansCardClassName="p-0 md:p-6 bg-transparent md:bg-card ring-0 md:ring" />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export const PricingModalPortal = withRenderPortal<
  PricingModalProps & WithRenderPortalProps
>(PortalName.pricing_modal)(PricingModalBase);
